import { configureStore } from '@reduxjs/toolkit'

import appReducer from './appSlice'
import packageReducer from './packageSlice.js'

const store = configureStore({
  reducer: {
    app: appReducer,
    packages: packageReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
